const size ={
    tabletLarge:"1024px",
    tablet: "768px",
    mobile: "500px",
    mobileSmall: "380px"
}

export const device = {
    tabletLarge: `(max-width: ${size.tabletLarge})`,
    tablet: `(max-width: ${size.tablet})`,
    mobile: `(max-width: ${size.mobile})`,
    mobileSmall: `(max-width: ${size.mobileSmall})`
}